var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"403","title":"403","sub-title":"Sorry, you are not authorized to access this page."}})
}
var staticRenderFns = []

export { render, staticRenderFns }